module.exports = __webpack_public_path__ + "img/logo-colored.d9e7589c.svg";